import type { SpaceNavD0Overrides } from './useSimplifiedSpaceNav.ts';

const CALENDARS_KEY = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';

export type SpaceNavVisibility = {
	showShortcutsSection: boolean;
	blogsHidden: boolean;
	main: readonly { webItemCompleteKey?: string | null }[];
};

/**
 * Merges D0 overrides with existing space-settings-driven visibility.
 *
 * Additive-only: D0 can only hide items that would otherwise be shown,
 * never show items that the admin has hidden via space settings.
 */
export function applySpaceNavD0Overrides<TMain extends { webItemCompleteKey?: string | null }>(
	current: {
		showShortcutsSection: boolean;
		blogsHidden: boolean;
		main: TMain[];
	},
	overrides: SpaceNavD0Overrides,
): {
	showShortcutsSection: boolean;
	blogsHidden: boolean;
	main: TMain[];
} {
	return {
		showShortcutsSection: current.showShortcutsSection && !overrides.hideShortcuts,
		blogsHidden: current.blogsHidden || overrides.hideBlogs,
		main: overrides.hideCalendar
			? current.main.filter((link) => link.webItemCompleteKey !== CALENDARS_KEY)
			: current.main,
	};
}
